{
  "equipment": {
    "add": "Add",
    "equipment": "Equipment",
    "equipmentList": "Equipment List",
    "equipmentDetails": "Equipment Details",
    "viewEquipmentDetails": "View Equipment Details",
    "filterEquipment": "Filter Equipment",
    "equipmentActions": "Equipment Actions",
    "equipmentUseCase": "Equipment Use Case",
    "chargingType": "Charging Type",
    "meter": "Meter",
    "serialVin": "Serial / VIN",
    "manufacturer": "Manufacturer",
    "modelYear": "Model Year",
    "modelNumber": "Model Number",
    "unitNo": "Unit Number",
    "meteredKwh": "Metered kWh",
    "activityStatus": "Activity Status",
    "meterType": "Meter Type",
    "editMetered": "Edit Metered",
    "editUnmetered": "Edit Unmetered",
    "addEquipment": "Add Equipment",
    "viewEquipmentId": "View Equipment ID",
    "save": "Save",
    "metered": "Metered",
    "unmetered": "Unmetered",
    "updateMeteredEquipmentUsage": "Update Metered Equipment Usage",
    "bulkEditAllKwh": "Bulk edit all metered kWh",
    "bulkEditAllKwhHelp": "This value will be applied to every metered equipment unit for this reporting period.",
    "noMeteredEquipmentUsageDataFound": "No metered equipment usage data was found for this quarter.",
    "noUsageDataFound": "No usage data was found for this equipment.",
    "operationDetails": "Operation Details",
    "chargingCyclesShift": "Charging Cycles / Shift",
    "shiftsDay": "Shifts / Day",
    "workDaysQuarter": "Work Days / Quarter",
    "percentUptime": "Uptime",
    "maxSiteDeliverabilityKw": "Max Site Deliverability (kW)",
    "chargerEfficiencyRating": "Charger Efficiency Rating",
    "chargeReturnFactor": "Charge Return Factor",
    "depthOfDischarge": "Depth of Discharge",
    "periodHasBeenLockedAndCannotBeEdited": "This period has been locked and cannot be edited.",
    "periodHasBeenFinalizedAndCanNoLongerBeEdited": "This period has been finalized and can no longer be edited.",
    "whatAreYouChargingOrPowering": "What are you charging or powering?",
    "equipmentCategory": "Equipment Category",
    "equipmentType": "Equipment Type",
    "serialNumber": "Serial Number",
    "nameplateRating": "Nameplate Rating (kW)",
    "unitNumber": "Unit Number",
    "chargingNetwork": "CNO/CMS",
    "retireEquipment": "Retire Equipment",
    "deleteEquipment": "Delete Equipment",
    "returnToFacility": "Return to Facility",
    "addNewEquipment": "Add New Equipment",
    "forkliftClassification": "Forklift Classification",
    "firstActiveReportingPeriod": "First Active Reporting Period",
    "fseRegistrationStatus": "FSE Registration Status",
    "approved": "Approved",
    "location": "Location",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "createdBy": "Created By",
    "createdAt": "Created Date",
    "equipmentUsage": "Equipment Usage",
    "saveUsage": "SAVE USAGE",
    "saveChangesTo": "Save changes to",
    "searchBySerial": "Search by Serial / VIN",
    "viewing": "Viewing",
    "pausedForSeasonality": "Paused for Seasonality",
    "fuelPathwayCode": "Fuel Pathway Code",
    "filterByCode": "Filter by Code...",
    "bookAndClaim": "Book & Claim",
    "applied": "Applied",
    "notApplied": "Not Applied",
    "batteryCapacityAh": "Battery Capacity (Ah)",
    "voltage": "Voltage",
    "chargeCyclesShift": "Charge Cycles / Shift",
    "usages": "Usages",
    "usage": "Usage",
    "usageDetails": "Usage Details",
    "category": "Category",
    "type": "Type",
    "recsRequired": "RECs Required",
    "creditsGenerated": "Credits Generated",
    "kwhPerChargeCycle": "kWh / Charge Cycle",
    "retireWarning": "Warning: Retiring this Equipment will discard any Usage data",
    "retireConfirmation": "I understand that all usage data after {{period}} will be discarded.",
    "retireMultipleConfirmation": "I understand that {{count}} selected equipment will be retired and all usage data after {{period}} will be discarded.",
    "deleteMultipleConfirmation": "I understand that {{count}} selected equipment will be permanently deleted and this cannot be undone.",
    "firstDayInService": "First Day in Service",
    "creatorDetails": "Creator Details"
  }
}
